import React, {useContext} from 'react';
import OrganizationHistoryTemplate from "../../../components/Templates/OrganizationHistoryTemplate";
import {useParams} from 'react-router-dom'
import LinkCell3 from "../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import UploadListsCell from "../../../components/Pages/TablePage/Table/Cells/UploadLists/UploadLists";
import {MedCenter_API} from "../MedCenter_API";
import TextCell from "../../../components/Pages/TablePage/Table/Cells/NewCells/TextCell/TextCell";
import {AuthContext} from "../../../context/AuthContext";

function OrgHistory(props) {
    const {orgId, orgName} = useParams()
    const {REACT_APP_URL_PREFIX} = process.env
    const {uploadCSV} = MedCenter_API.organizationHistory
    const {token} = useContext(AuthContext)
    const linkCell = (props) => {
        return <LinkCell3
            linkRoute={REACT_APP_URL_PREFIX + `/counterAgents/orgList/${orgId}/${orgName}/orgHistory/${props.idArr[0]}/${props.cellContent['name']}/${props.idArr[1]}/patient`}
            linkTitle={props.cellContent['name']}/>
    }
    const upload = props => {
        return <UploadListsCell uploaded={props.cellContent.uploaded}
                                api={uploadCSV(token.userId,props.idArr[2], props.idArr[1], props.idArr[0]).api}/>
    }


    return (
        <OrganizationHistoryTemplate
            getOrgHistoryAPI={`/api/v2/medCenters/${token.userId}/organizations/${orgId}/histories?`}
            addNewStudyConfig={false}
            filterBarConf={
                {
                    name: true,
                    period: true,
                    date: true,
                    base: true
                }
            }
            breadCrumbsItems={[
                {title: 'Контрагенты', link: REACT_APP_URL_PREFIX + '/counterAgents/orgList'},
                {
                    title: orgName,
                    link: REACT_APP_URL_PREFIX + `/counterAgents/orgList/${orgId}/${orgName}/orgHistory`,
                    actual: true
                },
            ]}
            tableModel={{
                haveToShow: [
                    {
                        id: 'organization_info',
                        idArr: ['id', 'verification_id'],
                        type: 'reactRouterCell',
                        typeData: {show: 'name', cell: linkCell}
                    },
                    {
                        id: 'document',
                        type: 'wrapperCell',
                        idArr: ['id', 'verification_id', 'organization_id',],
                        typeData: {cell: upload}
                    },
                    {
                        id: 'date',
                        type: 'wrapperCell',
                        typeData: {
                            cell: props => <TextCell
                                text={props.cellContent}/>
                        }
                    },
                    {id: 'results_count'},
                    {id: 'base'},
                    {id: 'invite_count'},
                ],
                firstRow:
                    [
                        {title: 'Название', id: 'name'},
                        {title: 'Загрузить списки', id: ''},
                        {title: 'Дата', id: 'resultDate'},
                        {title: 'Исследований', id: ''}, // Сортировка не добавлена
                        {title: 'Вид исследования', id: 'base'},
                        {title: 'Вызов', id: ''}, // Сортировка не добавлена
                    ],
            }}
        />
    );
}

export default OrgHistory;

